import { useCallback } from 'react';

import { useMatch, useNavigate } from 'react-router-dom';
import { SegmentedControl } from 'ui';

const StudentFeesRouteSegmentedControl = () => {
  const navigate = useNavigate();
  const isFeesRoute = useMatch('student-fees/fees/*');
  const handleChange = useCallback(
    (value: string) => {
      if (value === 'fees') {
        navigate('fees');
      } else {
        navigate('students');
      }
    },
    [navigate]
  );
  return (
    <SegmentedControl
      variant="light"
      value={isFeesRoute ? 'fees' : 'students'}
      onChange={handleChange}
      data={[
        { label: 'Students', value: 'students' },
        { label: 'Fees', value: 'fees' },
      ]}
      size="sm"
    />
  );
};

export { StudentFeesRouteSegmentedControl };
